import React from 'react';
import background from '../../assets/broccoli.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoRecipes extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="TAKE ACTION"
        description="Eco Recipes"
        paragraph="A balanced diet can improve your health, save money and help fight climate change."
        background={background}
     />
  
  );
 }
}   

export default InfoRecipes;